import { createTheme } from '@mui/material/styles';

import { baseTheme, getCommonThemesProps } from './baseTheme';
import { aureaColors } from './colors';

export const themeAurea = () => {
  const theme = baseTheme();

  const themeProperties = getCommonThemesProps(aureaColors);
  const { palette, components } = themeProperties;

  return createTheme({
    breakpoints: theme.breakpoints,
    palette,
    components,
    customLogo: {
      logo: 'AUREA_LOGO',
      slogo: 'AUREA_SLOGO',
      nlogo: 'AUREA_NLOGO',
      clogo: 'AUREA_CLOGO',
    },
    verticalBreakpoints: theme.verticalBreakpoints,
    typography: theme.typography,
  });
};

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  window.theme = themeAurea();
}
